var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C10.9669 0 0 10.9669 0 24.5C0 38.0331 10.9669 49 24.5 49C38.0331 49 49 38.0331 49 24.5C49 10.9669 38.0281 0 24.5 0ZM24.5 45.6718C12.8064 45.6718 3.32815 36.1936 3.32815 24.5C3.32815 12.8064 12.8064 3.32815 24.5 3.32815C36.1936 3.32815 45.6718 12.8064 45.6718 24.5C45.6718 36.1936 36.1936 45.6718 24.5 45.6718Z",
    fill: "#0D0D0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4398 24.5001C26.4398 25.5727 25.5677 26.4398 24.495 26.4398C23.4274 26.4398 22.5553 25.5376 22.5553 24.47C22.5603 20.2647 23.6279 11.9042 24.1793 9.21263C24.2494 8.86679 24.7457 8.86679 24.8158 9.21263C25.3672 11.9193 26.4398 20.3349 26.4398 24.5001Z",
    fill: "#0D0D0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3397 26.0438C19.207 25.8533 15.8137 25.1767 13.9642 24.8008C13.6885 24.7456 13.6885 24.3497 13.9642 24.2895C15.7035 23.9336 18.8712 23.3121 21.8535 23.0765C21.8335 23.5527 21.8184 24.0188 21.8184 24.47C21.8134 25.0564 21.9387 25.6077 22.3397 26.0438Z",
    fill: "#0D0D0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.21026C24.9899 6.21026 25.3871 5.81306 25.3871 5.32309C25.3871 4.83311 24.9899 4.43591 24.5 4.43591C24.01 4.43591 23.6128 4.83311 23.6128 5.32309C23.6128 5.81306 24.01 6.21026 24.5 6.21026Z",
    fill: "#0D0D0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32309 25.3871C5.81306 25.3871 6.21026 24.9899 6.21026 24.5C6.21026 24.01 5.81306 23.6128 5.32309 23.6128C4.83311 23.6128 4.43591 24.01 4.43591 24.5C4.43591 24.9899 4.83311 25.3871 5.32309 25.3871Z",
    fill: "#0D0D0F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 44.5641C24.9899 44.5641 25.3871 44.1669 25.3871 43.677C25.3871 43.187 24.9899 42.7898 24.5 42.7898C24.01 42.7898 23.6128 43.187 23.6128 43.677C23.6128 44.1669 24.01 44.5641 24.5 44.5641Z",
    fill: "#0D0D0F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.677 25.3871C44.1669 25.3871 44.5641 24.9899 44.5641 24.5C44.5641 24.01 44.1669 23.6128 43.677 23.6128C43.187 23.6128 42.7898 24.01 42.7898 24.5C42.7898 24.9899 43.187 25.3871 43.677 25.3871Z",
    fill: "#0D0D0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.a0d6757afaf9233bd04cfb8905802db8.svg";
export { ForwardRef as ReactComponent };